import React, { useContext, useState, useEffect, useCallback } from "react";

import {
  Context,
  masqueradeTeacher,
  MASQUERADE_TEACHER_SUCCESS_MESSAGE,
  clearSuccessMessage,
} from "../../../managerStore";
import { APP } from "../../../Definition";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

import RegistrationStepsSection from "./RegistrationStepsSection";
import LinksSection from "./LinksSection";
import styles from "./HomePage.module.scss";

const HomePage = () => {
  const { state, dispatch } = useContext(Context);
  const [, peep] = useWaitApiCall(state);

  const [proxyLoginApp, setProxyLoginApp] =
    useState<typeof APP[keyof typeof APP]>();

  const onemenuLogin = useCallback(() => {
    setProxyLoginApp(APP["onemenu"]);
    dispatch(peep(masqueradeTeacher(state.manager.id, APP["onemenu"])));
  }, [dispatch, peep, state.manager.id]);

  const dlpLogin = useCallback(() => {
    setProxyLoginApp(APP["dlp"]);
    dispatch(peep(masqueradeTeacher(state.manager.id, APP["dlp"])));
  }, [dispatch, peep, state.manager.id]);

  const gearLogin = useCallback(() => {
    setProxyLoginApp(APP["g4s"]);
    dispatch(peep(masqueradeTeacher(state.manager.id, APP["g4s"])));
  }, [dispatch, peep, state.manager.id]);

  const getAppUrl = useCallback((app: typeof APP[keyof typeof APP]) => {
    const appURLs = {
      [APP["onemenu"]]: process.env.REACT_APP_TEACHER_ONEMENU_URL,
      [APP["dlp"]]: process.env.REACT_APP_TEACHER_DLP_URL,
      [APP["g4s"]]: process.env.REACT_APP_TEACHER_APP_URL,
    };
    return appURLs[app];
  }, []);

  useEffect(() => {
    if (state.success_message === MASQUERADE_TEACHER_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      const appUrl = proxyLoginApp ? getAppUrl(proxyLoginApp) : null;
      appUrl &&
        window.open(
          `${appUrl}?session_id=${state.temporary_session_id}`,
          "_blank",
        );
    }
  }, [
    dispatch,
    state.success_message,
    state.temporary_session_id,
    proxyLoginApp,
    getAppUrl,
  ]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <RegistrationStepsSection />
        <LinksSection
          onemenuLogin={onemenuLogin}
          dlpLogin={dlpLogin}
          gearLogin={gearLogin}
        />
      </div>
    </div>
  );
};

export default HomePage;
